<template>
  <nav class="nav-links">
    <button :class="['nav-link-item', { active: isActive('feed') }]" @click="navigateTo(`${prefix}/feed`)">FEED</button>
    <button :class="['nav-link-item', { active: isActive('talents') }]" @click="navigateTo(`${prefix}/talents`)">TALENTS</button>
    <button :class="['nav-link-item', { active: isActive('reads') }]" @click="navigateTo(`reads`)">READS</button>
  </nav>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import {defineProps, watch, ref, onMounted} from 'vue';
defineProps({
  prefix: {
    type: String,
    default: 'viewer'
  }
});

const route = useRoute();
const router = useRouter();
const tabVal = ref<any>(null);
const isActive = (tab: string) => {
  console.log('is active', tab, route.path, tabVal.value);
  return route.path.includes(`/field/${tab}`) || route.path.includes(`/${tab}`);
};

watch(() => route.query, async () => {
  if (route.query.tab) {
    tabVal.value = route.query.tab;
  } else {
    tabVal.value = null;
  }
});
onMounted(() => {
  if (route.query.tab) {
    tabVal.value = route.query.tab;
  } else {
    tabVal.value = null;
  }
});
const navigateTo = (tab: string) => {
  router.push(`/${tab}`);
};
</script>

<style scoped>
.nav-links {
  display: flex;
  gap: 6px;
}

.nav-link-item {
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 100px;
  padding: 4px 16px;
  text-decoration: none;
  font-weight: 400;
  font-size: 10px;
  line-height: 1;
  vertical-align: middle;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  transition: all 0.2s ease;
  cursor: pointer;
  background-color: transparent;
}

.nav-link-item:hover, .nav-link-item.active {
  background-color: #fff;
  border-color: #fff;
  color: rgba(0, 0, 0, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.nav-link-item.active {
  background-color: #fff;
  border-color: #fff;
  color: rgba(0, 0, 0, 1);
  font-weight: 500;
}
</style>
